import React from "react";
import {formatMoney, getImage} from "../../../../../_utils";

export default function PhysicalCardFront({ settings, preview, giftCard }) {

  let codeParts = ["", "", "", ""];

  // Split into bits of 4
  if (typeof(giftCard.issued_gift_card_code) == "string" ) {
    codeParts = giftCard.issued_gift_card_code.match(new RegExp('.{1,4}', 'g'));
  }

  const expiryYears = (() => {

    if (giftCard.expiry_date !== null) {
      return new Date(giftCard.expiry_date).getFullYear();
    }

    return new Date(new Date().setFullYear(new Date().getFullYear() + 5)).getFullYear();

  })();

  const month     = new Date().getMonth();
  const expiry    = `${month}/${expiryYears}`;

  const topImage  = settings.physical.greeting_card.inside_top_background_image;
  const gcImage   = settings.physical.giftcard.gift_card_front_image;

  const cardImage = (giftCard.selected_card_image.includes("not-found") && preview)
    ? getImage(settings.physical.greeting_card.selected_images.find((c) => c.images.length)?.images[0])
    : giftCard.selected_card_image;

  return (
    <div className="gc__animated-card-front">
      <div className="gc__giftcard_image">
        <img
          src={cardImage}
          alt="Giftcard image"
        />
      </div>
      <div
        className="gc__giftcard_wrapper"
        id="gc__id-printable"
      >
        <div
          className="gc__greeting_top"
          style={{
            backgroundImage: (topImage) ? `url('${topImage}')` : undefined,
            backgroundSize: (topImage) ? "contain" : undefined
          }}
        />
        <div className="gc__gift-card">
          <div
            className="gc__gift_card_front"
            style={{
              backgroundImage: (gcImage) ? `url('${gcImage}')` : undefined,
              backgroundSize: (gcImage) ? "contain" : undefined
            }}
          />
        </div>
      </div>
    </div>
  );
};
